import React from 'react';

const clients = ['Microsoft', 'Amazon', 'Google', 'IBM', 'Accenture', 'Deloitte'];

const CorporateClients = () => {
  return (
    <div className="bg-gray-50 text-center p-12 w-max-7xl">
      <h2 className="text-2xl font-bold text-blue-900 mb-8">Our Corporate Clients</h2>
      <div className="flex flex-wrap justify-center gap-6 px-4">
        {clients.map((client, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-md px-6 py-4 text-gray-500 font-medium
              w-full sm:w-[45%] md:w-[30%] lg:w-[15%] text-center"
          >
            {client}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CorporateClients;
